import '.h{display:grid;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import '.ig{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { CtaCard } from '@app/components/blocks/card/CtaCard'
import searchForGroup from '@app/assets/images/search-for-group.png'
import consultExperts from '@app/assets/images/consult-experts.png'
import findLocation from '@app/assets/images/find-location.png'
import { pages } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'

export const AboutSection = () => {
  const t = useTranslations().app.landingPage
  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.aboutSection.title}
        subtitle={t.aboutSection.subTitle}
        seeMore={t.aboutSection.seeMore}
        toRoute={pages.knowledgeHub}
      />
      <styled.div className="h j ig"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },
        }}
      >
        <CtaCard
          title={t.aboutSection.cta[0].title}
          subtitle={t.aboutSection.cta[0].subtitle}
          illustration={searchForGroup}
          linkText={t.aboutSection.seeMore}
          linkHref={
            pages.knowledgeHubModule('je-account-project') +
            '?slug=hoe-werkt-crowdbuilding'
          }
        />
        <CtaCard
          title={t.aboutSection.cta[1].title}
          subtitle={t.aboutSection.cta[1].subtitle}
          illustration={findLocation}
          linkText={t.aboutSection.seeMore}
          linkHref={pages.plots}
        />
        <CtaCard
          title={t.aboutSection.cta[2].title}
          subtitle={t.aboutSection.cta[2].subtitle}
          illustration={consultExperts}
          linkText={t.aboutSection.seeMore}
          linkHref={pages.serviceProviders}
        />
      </styled.div>
    </Column>
  )
}
